import { render, staticRenderFns } from "./articleListByTag.vue?vue&type=template&id=f650597a&scoped=true&"
import script from "./articleListByTag.vue?vue&type=script&lang=js&"
export * from "./articleListByTag.vue?vue&type=script&lang=js&"
import style0 from "./articleListByTag.vue?vue&type=style&index=0&id=f650597a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f650597a",
  null
  
)

export default component.exports